<div class="absolute z-5 h-3/6 flex-center" style="width: -webkit-fill-available">
    <object
    alt="progress loader"
    rel="progress loader"
    class="max-w-[7rem]"
    type="image/svg+xml"
    data="https://cdn.chipychapa.com//welle/General_site/Loader/loader.svg"></object>
</div>
